module.exports = __webpack_public_path__ + "static/2front-about-company-methods-3-987ccd316cac69639448742867ddd2bf.png";